/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const uiSchemaProperties = Object.freeze({
  KIND: 'kind',
  TITLE_FIELD: 'titleField',
  CONFIRM_BUTTON: 'confirmButton',
  USER_REFERENCE: 'userReference',
  UI_READONLY: 'ui:readOnly',
  UI_SUMMARY: 'ui:summary',
  UI_TITLE: 'ui:title',
  UI_TITLE_SINGULAR: 'ui:titleSingular',
  UI_TITLE_SINGULAR_ADD: 'ui:titleSingularAddSection',
  UI_DATA: 'ui:data',
  UI_DESCRIPTION: 'ui:description',
  UI_DEFINITION: 'ui:definition',
  UI_VALIDATION: 'ui:validation',
  UI_ACTIONBAR: 'ui:actionBar',
  UI_DISABLED: 'ui:disabled',
  UI_APPLICANT_APRROVAL: 'ui:applicantApproval',
  UI_ENABLED: 'ui:enabled',
  UI_HELP_SEVERITY: 'ui:help:severity',
  UI_SUMMARY_ITEM: 'ui:summaryItem',
  UI_TOOLTIP: 'ui:tooltip',
  UI_SEPARATOR: 'ui:separator',
  UI_INFO_MESSAGE: 'ui:infoMessage',
  UI_ERROR_MESSAGE: 'ui:errorMessage',
  UI_HIDE_ADD_BUTTON: 'ui:hideAddButton',
  UI_HIDE_ADD_ADDRESS_BOOK_BUTTON: 'ui:hideAddAddressBookButton',
  UI_HIDE_DELETE_BUTTON: 'ui:hideDeleteButton',
  UI_HIDE_ARRAY_TITLE: 'ui:hideArrayTitle',
  UI_AUTOCOMPLETE: 'ui:autocompleteField',
  UI_AUTOCOMPLETE_SKIP: 'ui:autocompleteSkip',
  UI_AUTOCOMPLETE_SHOW_VALIDATION_TICK: 'ui:showValidationTick',
  UI_AUTOCOMPLETE_SKIP_REPLACE_DIALOG: 'ui:autocompleteSkipReplaceDialog',
  UI_SHOULD_USE_INITIAL_DATA: 'ui:shouldUseInitialData',
  UI_AUTOCOMPLETE_TRIGGER: 'ui:autocompleteTrigger',
  UI_AUTOCOMPLETE_CATEGORY: 'ui:autocompleteCategory',
  UI_WIDGET_MANDATORY: 'ui:widgetMandatory',
  UI_WIDGET_TRIGGER: 'ui:widgetTrigger',
  UI_WIDGET_AUTO_FILL_TRIGGER: 'ui:autoFillTrigger',
  UI_COMPONENT_EDITABLE: 'ui:componentEditable', // property to mark that a component can update multiple fields in a section
  UI_OPTIONS: 'ui:options',
  UI_ENABLED_CATEGORIES: 'ui:enabledCategories',
  UI_HIDDEN: 'ui:hidden',
  UI_SUMMARY_INITIAL_ITEMS: 'ui:summaryInitialItems',
  UI_STYLINGVARIANTS: 'ui:stylingVariants',
  UI_SUMMARYBUTTON: 'ui:summaryButton',
  UI_VARIANT_TITLE: 'ui:variantTitle',
  UI_NO_BOTTOM_SPACING: 'ui:noBottomSpacing',
  DIALOG_ID: 'dialog:id',
  DIALOG_TITLE: 'dialog:title',
  DIALOG_DESCRIPTION: 'dialog:description',
  DIALOG_ACTIONS: 'dialog:actions',
  DIALOG_OPTIONS: 'dialog:options',
  DIALOG_BUSINESS_RULES_PREFIX: 'dialog:businessRulesPrefix',
  UI_CONFIG: 'ui:config',
  UI_ICON: 'ui:icon',
  UI_HIDE_LAYOUT_SWITCHER: 'ui:hideLayoutSwitcher',
  UI_DISABLE_DRAG_AND_DROP: 'ui:disableDragAndDrop',
  UI_SECTIONS: 'ui:sections',
  UI_HIDE_SUMMARY: 'ui:hideSummary',
  UI_HIDE_PREVIEW_BUTTON: 'ui:hidePreviewButton',
  UI_FILE_IMPORT: 'ui:fileImport',
  ATTACHMENTS_CATEGORIES: 'attachments:categories',
  ATTACHMENTS_OVERWRITTEN_FORM_KEY: 'attachments:overwrittenFormKey', // replaces the form attachment field key
  ATTACHMENTS_UPLOADER_TITLE_HIDDEN: 'attachments:uploaderTitleHidden', // set to true to hide the uploader title
  ATTACHMENTS_UPLOADER_SUBTITLE_VISIBLE: 'attachments:uploaderSubtitleVisible', // displays a subtitle under the uploader title
  ATTACHMENTS_USER_SPECIFIC: 'attachments:userSpecific', // displays only attachments that belong to the current user
  ATTACHMENTS_SHOW_COMPLIANCE_INFO: 'attachments:showComplianceInfo', // displays a link that triggers the compliance rules dialog (for SPCs)
  ATTACHMENTS_SHOW_DRAWINGS_COMPLIANCE_INFO: 'attachments:showDrawingsComplianceInfo',
  ATTACHMENTS_CUSTOM_TOOLTIPS: 'attachments:customTooltips',
  ATTACHMENTS_SHOW_TOOLTIPS: 'attachments:showTooltips', // displays a link that triggers the compliance rules dialog (for SPCs)
  ALLOWED_FILE_FORMATS: 'attachments:allowedFileFormats', // displays a link that triggers the compliance rules dialog (for SPCs)
  UI_SHOW_FINISH_PAYMENT: 'ui:showFinishPayment',
  UI_FINISH_PAYMENT_LABEL: 'ui:finishPaymentLabel',
  ATTACHMENTS_USE_DEFAULT_VALUE: 'attachments:useDefaultValue', // if set to false then dropdown is visible even if there is just one element, default is true
  UI_HIDE_SEND_WITHOUT_PAYMENT_BUTTON: 'ui:hideSendWithoutPaymentButton',
});
